import * as Yup from 'yup';

const SigninSchema = Yup.object().shape({
    identifier: Yup.string()
        .required('Required'),
    password: Yup.string()
        .required('Required')
});

export { SigninSchema }